@import "../../theme/global";

lar-button-group {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  margin: 2rem auto;
  padding: 0.4rem;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 0.8rem;
  box-shadow:
    inset 0 1px 3px rgba(0, 0, 0, 0.08),
    0 1px 0 rgba(255, 255, 255, 0.5);
}

lar-button-group lar-button {
  flex: 1;
  min-height: 3.5rem;
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 0.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 2px 8px -2px rgba(0, 0, 0, 0.15),
    0 1px 2px rgba(0, 0, 0, 0.1);
}

lar-button-group lar-button:active {
  transform: scale(0.97);
}
